import React, { useState, useMemo } from 'react';
import { inject } from 'mobx-react';
import { withStyles } from '@material-ui/core';
import { compose } from 'recompose';
import { withUserProfile } from '../../../../userProfile/userProfileContext';
import IBBillsGrid from "./BillsGrid";
import CustomerGridConfig from './CustomerGridConfig';
import Grid from './Grid';
import { getFilteredData } from '../../../common/filterUtilities';
import { getPriorityOptions } from '../../utils';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  seperator: {
    height: 24
  },
  hidden: {
    display: 'none'
  }
});

const GRID_DETAIL = {
  CUSTOMER: {
    name: 'Customers',
    totalLabel: 'customers',
    loadingKey: 'loadingCustomers',
    loadedKey:'loadedCustomers'
  },
  BILLS:{
    name: 'IB Bills',
    totalLabel: 'bills',
    loadingKey: 'loadingBills',
    loadedKey:'loadedBills'
  }
}

const GridsContainer = ({ customers, bills, classes, userData, activeFilter, quickFilter, isCustomersLoading, isBillsLoading, IBPlanningStore }) => {
  const [filterCustomer, setFilterCustomer] = useState('');
  const [maximizeGrid, setMaximizeGrid] = useState('');
  const priorityOptions = getPriorityOptions(IBPlanningStore.serviceLevelList);
  const onSelection = (data) => {
    if (data) {
      setFilterCustomer(data.customerCode);
    } else {
      setFilterCustomer('');
    }
  };

  const onMaximizeGrid = (gridName) => {
    if (gridName === maximizeGrid) {
      setMaximizeGrid('');
    } else {
      setMaximizeGrid(gridName);
    }
  };

  const { billsData, customersData } = useMemo(() => {
    let billsData = bills?.data || [];
    let customersData = customers?.data || [];

    if (filterCustomer) {
      billsData = billsData.filter(({ customerCode }) => customerCode === filterCustomer);
    }

    if (quickFilter) {
      billsData = getFilteredData(billsData, quickFilter, new Date());

      // Filter customers data based on the customer codes in the bills data
      const customerCodes = new Set(billsData.map(({ customerCode }) => customerCode));
      customersData = customersData.filter(({ customerCode }) => customerCodes.has(customerCode));
    }

    return { billsData, customersData };
  }, [bills?.data, customers?.data, filterCustomer, quickFilter]);

  return (
    <div className={classes.container}>
      <div className={`${classes.container} ${maximizeGrid === GRID_DETAIL.BILLS.name ? classes.hidden : ''}`}>
        <Grid
          activeFilterName={activeFilter}
          title={GRID_DETAIL.CUSTOMER.name}
          gridConfig={CustomerGridConfig.getConfiguration({
            name: customers.gridName,
            userConfig: userData.userProfile?.columnPref
          })}
          data={customersData}
          totalLabel={GRID_DETAIL.CUSTOMER.totalLabel}
          onSelection={onSelection}
          onMaximize={() => onMaximizeGrid(GRID_DETAIL.CUSTOMER.name)}
          isLoading={isCustomersLoading}
          context={{ priorityOptions }}
        />
      </div>
      <div className={`${classes.seperator} ${maximizeGrid ? classes.hidden : ''}`}></div>
      <div className={`${classes.container} ${maximizeGrid === GRID_DETAIL.CUSTOMER.name ? classes.hidden : ''}`}>
        <IBBillsGrid
          activeFilterName={activeFilter}
          title={GRID_DETAIL.BILLS.name}
          gridName={bills.gridName}
          data={billsData}
          totalLabel={GRID_DETAIL.BILLS.totalLabel}
          userData={userData}
          onMaximize={() => onMaximizeGrid(GRID_DETAIL.BILLS.name)}
          isLoading={isBillsLoading}
        />
      </div>
    </div>
  );
};

export default compose(withStyles(styles), withUserProfile, inject('IBPlanningStore'))(GridsContainer);
